<template>

    <div class="mt-5">
        <h3>{{ lang('all.nieuwsbrief') }}</h3>

        <checkbox-input
            v-model="subscribed"
            :label="lang('all.ja_ik_wil_ingeschreven_zijn_op_de_nieuwsbrief_van', {'%shopname%': shopname})"
        ></checkbox-input>

        <div>
            <button
                class="mt-3 btn btn-primary"
                :disabled="!canSubmit"
                @click="onSubmit"
            >
                {{ lang('all.nieuwsbrief_instellingen_opslaan') }}
            </button>
        </div>
    </div>

</template>

<script>

import CheckboxInput from "../../Common/CheckboxInput";

export default {

    components: {
        CheckboxInput,
    },

    computed: {
        canSubmit() {
            return this.subscribed !== this.isSubscribed;
        },

        shopname() {
            return this.$page.props.name;
        },
    },

    data() {
        return {
            posting:false,
            subscribed:true,
        }
    },

    methods:{
        onSubmit(){
            if (!this.canSubmit) {
                return;
            }
            this.posting = true;
            this.$inertia.post(this.route('auth.myaccount.details.mailinglist.store'), {
                subscribed:this.subscribed
            }, {
                onFinish: () => this.posting = false,
            });
        },
    },

    mounted() {
        this.subscribed = JSON.parse(JSON.stringify(this.isSubscribed));
    },

    name:'MyAccountMailinglist',

    props: {
        isSubscribed: {
            required:true,
            type:Boolean,
        },
    },

}

</script>
